/**
 * Build a Google Calendar "add event" URL that pre-fills the given event.
 *
 * Google's event-template link:
 *   https://calendar.google.com/calendar/render?action=TEMPLATE
 *     &text=<title>
 *     &dates=<YYYYMMDDTHHmmssZ>/<YYYYMMDDTHHmmssZ>   ← UTC, "Z" suffix
 *     &details=<description>
 *     &location=<location>
 *     &sf=true&output=xml
 *
 * All-day events use YYYYMMDD without the time part. Google treats the
 * second date as EXCLUSIVE for all-day events, so we bump by one day.
 */

function fmtDateUTC(iso, allDay) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  if (allDay) {
    return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}`;
  }
  return (
    `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}` +
    `T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`
  );
}

export function buildGoogleCalendarUrl(event) {
  const title = event.title || 'Family event';
  const location = event.location || '';
  const description = (event.description || '') + '\n\nAdded from Kinsy';
  const allDay = !!event.all_day;

  let start = event.start_date;
  let end = event.end_date || event.start_date;

  // Google's all-day end date is exclusive — bump by 1 day.
  if (allDay && end) {
    const d = new Date(end);
    d.setUTCDate(d.getUTCDate() + 1);
    end = d.toISOString();
  }

  const dates = `${fmtDateUTC(start, allDay)}/${fmtDateUTC(end, allDay)}`;
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title,
    dates,
    details: description,
    location,
    sf: 'true',
    output: 'xml',
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
